import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { IUnidadeMedida } from '../types/unidadesMedida';

export const useUnidadesMedida = () => {
    const [unidadesMedida, setUnidadesMedida] = useState<IUnidadeMedida[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchUnidadesMedida = async () => {
        try {
            setLoading(true);
            const response = await apiService.getUnidadesMedida();
            setUnidadesMedida(response.data);
            setError(null);
        } catch (err) {
            setError('Erro ao carregar unidades de medida. Por favor, tente novamente.');
            console.error('Erro ao buscar unidades de medida:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUnidadesMedida();
    }, []);

    return {
        unidadesMedida,
        loading,
        error,
        refetchUnidadesMedida: fetchUnidadesMedida
    };
};
